/** @format */

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ChartLineUp } from "@phosphor-icons/react/dist/ssr/ChartLineUp";
import { formatCurrency } from "../../../utility/currencyUtils";

export interface TotalContributionsHistoryProps {
	sx?: SxProps;
	totalAmount: number;
	totalContributions: number;
}

export function TotalContributionsHistory({
	sx,
	totalAmount,
	totalContributions,
}: TotalContributionsHistoryProps): React.JSX.Element {
	return (
		<Card sx={sx}>
			<CardContent>
				<Stack spacing={3}>
					<Stack
						direction="row"
						sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
						spacing={3}>
						<Stack spacing={1}>
							<Typography color="text.secondary" variant="overline">
								All-Time Contributions
							</Typography>
							<Typography variant="h4">
								{formatCurrency(totalAmount, "usd")}
							</Typography>
						</Stack>
						<Avatar
							sx={{
								backgroundColor: "#7c3aed",
								height: "56px",
								width: "56px",
							}}>
							<ChartLineUp size={24} color="#ffffff" />
						</Avatar>
					</Stack>
					<Stack direction="row" spacing={1} alignItems="center">
						<Typography variant="body2" color="text.secondary">
							{totalContributions.toLocaleString()} total contributions
						</Typography>
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
}
